import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { COMPANY, NAV_LINKS, SERVICES } from "../lib/data";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden bg-navy text-white"
    >
      <div className="grain" />
      <div className="relative z-10 mx-auto max-w-7xl px-6 py-20 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo light />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/60">
              UAE-based specialists in Marine Logistics & Manpower Services,
              supporting the global Oil & Gas industry with reliability and
              operational excellence.
            </p>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/40">
              Company
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/70 transition-colors duration-200 hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/40">
              Services
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/services"
                    className="text-white/70 transition-colors duration-200 hover:text-white"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/40">
              Contact
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brandred" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">
                  {COMPANY.email}
                </a>
              </li>
              {COMPANY.phones.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brandred" />
                  <a href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-white">
                    {p}
                  </a>
                </li>
              ))}
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brandred" />
                <span>{COMPANY.location}</span>
              </li>
            </ul>
            <Link
              to="/quote"
              className="mt-6 inline-flex items-center gap-1.5 rounded-sm bg-brandred px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brandred-600"
            >
              Request a Quote <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/40 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Mauresk Services. All rights reserved.</p>
          <p className="tracking-wide">Marine Logistics & Manpower — Oil & Gas Industry</p>
        </div>
      </div>
    </footer>
  );
}
